import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { NS } from '@/constants';
import { URLS } from '@/constants/urls';
import { useAppDispatch, useAppSelector } from '@/redux';
import { loadSensefuel } from '@/redux/epics/configuration.epic';
import { openModal, updateQuery } from '@/redux/slices/search.slice';
import styles from './Search.module.scss';

type SearchProps = {
	isMobile?: boolean;
};

export const Search = ({ isMobile = false }: SearchProps): React.JSX.Element => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation(NS.COMMON);
	const { storeConf } = useAppSelector(({ root }) => root);
	const query = useAppSelector(({ searchSlice }) => searchSlice.query);
	const sensefuelId = storeConf.sensefuelId;

	const [isFocused, setIsFocused] = useState(false);

	const handleOpen = () => {
		setIsFocused(true);

		if (sensefuelId) {
			dispatch(loadSensefuel());
			return;
		}

		dispatch(openModal());
	};

	const handleBlur = () => {
		setIsFocused(false);
	};

	const handleClear = () => {
		dispatch(updateQuery(''));
	};

	return (
		<div
			className={`${styles.search} ${isMobile ? styles['search-is-mobile'] : ''}`}
			data-rbf="navbar-search"
			data-test-id="navbar-search"
		>
			<div className={`${styles['search-bar']} ${isFocused ? styles.focused : ''} search-bar`}>
				<img
					onClick={handleOpen}
					src={URLS.ICON_SEARCH}
					className={styles.icon}
					alt="search"
					data-test-id="icon-search"
					data-rbf="icon-search"
					width={24}
					height={24}
				/>
				<input
					sensefuel-id="input-search"
					data-test-id="input-search"
					data-rbf="input-search"
					value={query}
					placeholder={t('btn.search')}
					onChange={(e) => dispatch(updateQuery(e.target.value))}
					onFocus={handleOpen}
					onBlur={handleBlur}
				/>
				{query.length > 0 && (
					<img
						onClick={handleClear}
						src={URLS.ICON_CLOSE}
						className={styles.icon}
						alt="close"
						data-test-id="close-search"
						data-rbf="close-search"
						width={16}
						height={16}
					/>
				)}
			</div>
		</div>
	);
};

export default Search;
